import { validatePassword } from './passwordUtils';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateSignupFields = ({ name, email, password, confirmPassword }) => {
  const fieldErrors = {};

  const trimmedName = name.trim();
  if (!trimmedName) {
    fieldErrors.name = 'Nome é obrigatório.';
  } else if (trimmedName.length < 2) {
    fieldErrors.name = 'Informe seu nome completo.';
  }

  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    fieldErrors.email = 'Email é obrigatório.';
  } else if (!EMAIL_REGEX.test(trimmedEmail)) {
    fieldErrors.email = 'Informe um email válido.';
  }

  if (!password) {
    fieldErrors.password = 'Senha é obrigatória.';
  } else {
    const passwordError = validatePassword(password);
    if (passwordError) fieldErrors.password = passwordError;
  }

  if (!confirmPassword) {
    fieldErrors.confirmPassword = 'Confirme sua senha.';
  } else if (password !== confirmPassword) {
    fieldErrors.confirmPassword = 'As senhas não coincidem.';
  }

  return fieldErrors;
};
